"use client";

import { Box } from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { AdVertical } from "@/sell/models/AdVerticals";
import Stepper from "../../ad/Stepper";
import Section from "../../ad/Section";
import { SellCreateForm } from "../SellCreateForm";

export default function AdPricingPage({ vertical }: { vertical: AdVertical }) {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: "grey.100",
        paddingTop: 4,
        paddingBottom: 8,
        paddingLeft: 1,
        paddingRight: 1,
        [theme.breakpoints.down("sm")]: {
          paddingTop: 2,
        },
      })}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          gap: 4,
          maxWidth: "1200px",
          margin: "0 auto",
          [theme.breakpoints.down("sm")]: {
            gap: 2,
          },
        })}
      >
        <Stepper activeStep={1} />
        <Section title="Your price" icon={<LocalOfferIcon />}>
          <SellCreateForm vertical={vertical} />
        </Section>
      </Box>
    </Box>
  );
}
